import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from "react";
import { createPortal } from "react-dom";
import GenericButton from "../helpers/GenericButton";
import useTailwindBreakpoint from "../../hooks/useTailwindBreakpoint";
export default function PlaceholderLayer({ children }) {
    const isLg = useTailwindBreakpoint("lg");
    const [mounted, setMounted] = React.useState(false);
    React.useEffect(() => {
        const id = requestAnimationFrame(() => setMounted(true));
        document.body.classList.add("overflow-hidden");
        return () => {
            document.body.classList.remove("overflow-hidden");
            cancelAnimationFrame(id);
        };
    }, []);
    return createPortal(_jsxs("div", { className: `${mounted ? "animate-in fade-in-0 duration-300" : "animate-out fade-out-0 duration-300"} supports-backdrop-filter:bg-background/60 pointer-events-auto fixed inset-0 z-49 min-h-screen min-w-screen overflow-x-hidden overflow-y-scroll py-10 backdrop-blur-lg **:no-underline md:py-16`, children: [_jsx("div", { className: "invisible mr-10 flex flex-row justify-end", children: _jsx("div", { children: _jsx(GenericButton, { variant: "close", size: isLg ? "md" : "sm", icon: true }) }) }), _jsx("div", { className: "mt-6 ml-3 flex flex-col gap-2 md:mt-8 md:ml-18 md:gap-4", children: children })] }), document.body);
}
